import React, {useRef} from "react";
import styled from "@emotion/styled";

import {Col, Container, Row} from "@pg-design/grid-module";
import {mb, mt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {Overlay} from "../../atoms/Overlay";
import {useHorizontalScrollOverlay} from "../../hooks/use_horizontal_scroll_overlay";

interface IProps {
    children: React.ReactNode;
    title: string;
}

export const InvestmentOfferTiles: React.FC<IProps> = (props) => {
    const typesRef = useRef(null);
    const {isLeftOverlayVisible, isRightOverlayVisible} = useHorizontalScrollOverlay(typesRef);

    return (
        <Container as="section" css={mt(8)}>
            <Text align="center" css={mb(2)} as="h2" variant="headline_3">
                {props.title}
            </Text>

            <Row>
                <Col>
                    <TilesList isLeftOverlayVisible={isLeftOverlayVisible} isRightOverlayVisible={isRightOverlayVisible} ref={typesRef} height="100%">
                        {props.children}
                    </TilesList>
                </Col>
            </Row>
        </Container>
    );
};

const TilesList = styled(Overlay)`
    display: flex;
    overflow: scroll;
    flex-wrap: nowrap;
    ${mt(3)};
    column-gap: 2.4rem;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        overflow: hidden;
        gap: 2.4rem;
        justify-content: center;
    }
`;
import React, {useRef} from "react";
import styled from "@emotion/styled";

import {Col, Container, Row} from "@pg-design/grid-module";
import {mb, mt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {Overlay} from "../../atoms/Overlay";
import {useHorizontalScrollOverlay} from "../../hooks/use_horizontal_scroll_overlay";

interface IProps {
    children: React.ReactNode;
    title: string;
}

export const InvestmentOfferTiles: React.FC<IProps> = (props) => {
    const typesRef = useRef(null);
    const {isLeftOverlayVisible, isRightOverlayVisible} = useHorizontalScrollOverlay(typesRef);

    return (
        <Container as="section" css={mt(8)}>
            <Text align="center" css={mb(2)} as="h2" variant="headline_3">
                {props.title}
            </Text>

            <Row>
                <Col>
                    <TilesList isLeftOverlayVisible={isLeftOverlayVisible} isRightOverlayVisible={isRightOverlayVisible} ref={typesRef} height="100%">
                        {props.children}
                    </TilesList>
                </Col>
            </Row>
        </Container>
    );
};

const TilesList = styled(Overlay)`
    display: flex;
    overflow: scroll;
    flex-wrap: nowrap;
    ${mt(3)};
    column-gap: 2.4rem;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        overflow: hidden;
        gap: 2.4rem;
        justify-content: center;
    }
`;
